// extracted by mini-css-extract-plugin
export default {"container":"Blogs_container__LxQk3"};